/**
 * Enum représentant un type de champs pour les cartes
 */
export enum TypeChampsCarte {
    NUM = 'NUM',
    NUM_DU_AU = 'NUM_DU_AU',
    NUM_DU_AU_DE_A = 'NUM_DU_AU_DE_A'
}
